import { loading, toast } from '@/shared/utils/UIHelper'
import AccountRepository from '@/shared/http/repositories/access/account'
import itemMixim from '@/views/private/operational/pci/mixins/itemMixim'
import CompanyMixin from '@/store/module/company/mixin'
import PDRDepartamentoContaRepository from '@/shared/http/repositories/pci/pdrdepartamentoconta'
import ItemTreeView from '@/views/private/operational/pci/components/treeview/ItemTreeView.vue'
import Tools from '@/components/tools/Tools'

export default {
  components: { ItemTreeView },
  data () {
    return {
      users: [],
      selectedUser: null,
      showItems: false,
      items: []
    }
  },
  mixins: [itemMixim, CompanyMixin],
  beforeMount () {
    Tools.MinimizedSidebar()
    loading.push()

    // Get accounts
    AccountRepository.GetAll()
      .then(response => {
        // Verifies response status
        if (response.data.code > 0) {
          // Stores only relevant data
          this.users = response.data.data.filter(ac => ac.grupo.nome !== 'ADMINISTRADORES').map(account => ({
            value: account.id,
            text: account.nome + ' (' + account.username + ')'
          }))
        }
      })
      .catch(error => {
        // Set toast
        toast.error(this.$lang.Common.Alerts.Error)
        console.log(error)
      })
      .finally(() => loading.close())
  },
  methods: {
    onSelectUser () {
      loading.push()

      this.showItems = false

      this.$nextTick(() => {
        // Get user items
        PDRDepartamentoContaRepository.GetAll(this.company.id, this.selectedUser)
          .then(response => {
            // Verifies response status
            if (response.data.code > 0) {
              // Format items to correct hierarchy

              const list = response.data.data.map(item => {
                return {
                  id: item.pdrDepartamento.id,
                  name: item.pdrDepartamento.descricao,
                  parentId: item.pdrDepartamento.pdrDepartamentoPaiID,
                  checked: item.checked
                }
              })

              // Get PCI itens hierarchy
              this.items = this.getHierarchy(list)

              this.showItems = true
            }
          })
          .catch(error => {
            toast.error(this.$lang.Common.Alerts.Error)
            console.log(error)
          })
          .finally(() => {
            loading.close()
          })
      })
    },
    saveUserAccess () {
      let _list = []

      const _getChecked = (item) => {
        if (item.children) {
          item.children.forEach(it => {
            _getChecked(it)
          })
          item.checked = item.children.some(it => it.checked)
        }

        if (item.checked) {
          _list.push({
            pdrDepartamento: {
              id: item.id
            }
          })
        }
      }

      this.items.forEach(it => {
        _getChecked(it)
      })

      loading.push()
      PDRDepartamentoContaRepository.Create(this.company.id, this.selectedUser, _list)
        .then(response => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          toast.error(this.$lang.Common.Alerts.Error)
          console.log(err)
        })
        .finally(() => loading.close())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/pci/departaments/departaments.js